module.exports = __webpack_public_path__ + "img/logo-pukyong.f4197a11.png";